import { createSlice } from "@reduxjs/toolkit";

const initState = {
  formData: [],
  lastStep: 1,
  id: "",
};

export const questionnaireSlice = createSlice({
  name: "questionnaire",
  initialState: initState,
  reducers: {
    setQuestionnaireReducer: (state, action) => {
      let tempObj = { ...state, ...action.payload };
      return tempObj;
    },
    resetQuestionnaireReducer: () => initState,
  },
});

export const { setQuestionnaireReducer, resetQuestionnaireReducer } =
  questionnaireSlice.actions;

export default questionnaireSlice.reducer;
